/**
 * EGDE Marquee — constant base scroll + velocity boost
 * The marquee always moves left at a steady pace.
 * When the user scrolls the page, the marquee speeds up.
 */
(function () {
  var section = document.getElementById('egde-marquee-scroll');
  if (!section) return;

  var track = section.querySelector('.egde-marquee__track');
  if (!track) return;

  var BASE_SPEED = 0.6;       // px per frame at rest (~36 px/s at 60fps)
  var BOOST_FACTOR = 4;       // how much scroll velocity multiplies speed
  var BOOST_DECAY = 0.92;     // how quickly the boost fades out (0–1)

  var position = 0;
  var boost = 0;
  var halfWidth = 0;
  var running = true;

  function measureHalf() {
    halfWidth = track.scrollWidth / 2;
  }

  // Wait for images to load before measuring
  var imgs = track.querySelectorAll('img');
  var loaded = 0;
  if (imgs.length > 0) {
    imgs.forEach(function(img) {
      if (img.complete) {
        loaded++;
        if (loaded === imgs.length) measureHalf();
      } else {
        img.addEventListener('load', function() {
          loaded++;
          if (loaded === imgs.length) measureHalf();
        });
      }
    });
  }
  measureHalf();
  window.addEventListener('load', measureHalf);
  window.addEventListener('resize', measureHalf);

  var lastScrollY = window.scrollY;
  var lastTime = performance.now();

  window.addEventListener('scroll', function () {
    var now = performance.now();
    var dt = Math.max(now - lastTime, 1);
    var dy = Math.abs(window.scrollY - lastScrollY);
    var velocity = dy / dt; // px/ms
    boost = Math.max(boost, velocity * BOOST_FACTOR);
    lastScrollY = window.scrollY;
    lastTime = now;
  }, { passive: true });

  function tick() {
    if (!running) return;

    var speed = BASE_SPEED + boost;
    position -= speed;

    // loop seamlessly
    if (halfWidth > 0 && Math.abs(position) >= halfWidth) {
      position += halfWidth;
    }

    track.style.transform = 'translateX(' + position + 'px)';

    // decay boost toward zero
    boost *= BOOST_DECAY;
    if (boost < 0.01) boost = 0;

    requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);

  // pause when tab hidden
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      running = false;
    } else {
      running = true;
      lastScrollY = window.scrollY;
      lastTime = performance.now();
      requestAnimationFrame(tick);
    }
  });
})();
